// Shared by browser/native routing and the Node-based native identity generator.
export const isStagingDeployment = (deployEnvironment, mode) =>
    ['staging', 'test', 'qa'].includes(String(deployEnvironment || mode || '').trim().toLowerCase());
